import { QueryClient } from '@tanstack/react-query';

/**
 * The worker app's one query client.
 *
 * Writes run whatever the phone reports. TanStack's default `'online'` mode
 * pauses a write while the phone says it is offline and replays it on
 * reconnect, so a pic tapped with no signal could land an hour late. With
 * `'always'` an offline write fails at once with its own error toast, and
 * nothing retries it: the worker taps again when he has signal.
 */
export function createWorkerQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
      mutations: {
        networkMode: 'always',
      },
    },
  });
}
